import React from 'react';
import AccountCreateForm from 'components/Account/AccountCreateForm/AccountCreateForm';

const AccountCreatePage: React.FC = () => {
  return <AccountCreateForm data-testId="account-create-form" />;
};

export default AccountCreatePage;
